import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, Heart, Calendar, ArrowRight } from 'lucide-react';
import styles from './Components/CSS/SimilarBlogs.module.css';

const SimilarBlogs = ({ blogs }) => {
  const navigate = useNavigate();

  const formatDate = (dateString) => {
    if (!dateString) return 'No date';
    return new Date(dateString).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  const formatReadTime = (content) => {
    if (!content) return '1 min read';
    const words = content.replace(/<[^>]*>/g, '').split(/\s+/).length;
    const readTime = Math.ceil(words / 200);
    return `${readTime} min read`;
  };

  const handleBlogClick = (slug, id) => {
    navigate(`/blog/${slug || id}`);
  };

  if (!blogs || blogs.length === 0) {
    return null;
  }

  return (
    <section className={styles.container}>
      <div className={styles.header}>
        <h2 className={styles.title}>Continue Reading</h2>
      </div>

      <div className={styles.blogGrid}>
        {blogs.map((blog) => (
          <article 
            key={blog.id} 
            className={styles.blogCard}
            onClick={() => handleBlogClick(blog.slug, blog.id)}
          >
            {(blog.featuredImage || blog.coverImage) && (
              <div className={styles.imageContainer}>
                <img 
                  src={blog.featuredImage || blog.coverImage} 
                  alt={blog.title}
                  className={styles.blogImage}
                />
                <div className={styles.imageOverlay} />
              </div>
            )}
            
            <div className={styles.blogContent}>
              <div className={styles.blogMeta}>
                <span className={styles.category}>{blog.category}</span>
                <span className={styles.readTime}>
                  {formatReadTime(blog.content)}
                </span>
              </div>

              <h3 className={styles.blogTitle}>{blog.title}</h3>
              
              {blog.content && (
                <p className={styles.blogExcerpt}>
                  {blog.content.replace(/<[^>]*>/g, '').substring(0, 120)}...
                </p>
              )}

              <div className={styles.blogFooter}>
                <div className={styles.authorInfo}>
                  <span className={styles.authorName}>
                    {blog.author?.name || 'Unknown Author'}
                  </span>
                  <span className={styles.publishDate}>
                    {formatDate(blog.createdAt)}
                  </span>
                </div>

                <div className={styles.blogStats}>
                  <div className={styles.statItem}>
                    <Eye size={14} />
                    <span>{blog.views || 0}</span>
                  </div>
                  <div className={styles.statItem}>
                    <Heart size={14} />
                    <span>{blog.likes || 0}</span>
                  </div>
                </div>
              </div>

              <div className={styles.readMoreButton}>
                <span>Read More</span>
                <ArrowRight size={16} />
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default SimilarBlogs;